const config = {
  signUpUrl: process.env.GATSBY_SIGNUP_URL,
  siteUrl: process.env.GATSBY_SITE_URL || 'https://sendgrid.com',
  env: process.env.GATSBY_SG_ENV || 'development',
};

export default config;
